import { bloomScale } from "../../lib/questions";
import { QuestionStepShell } from "./QuestionStepShell";
import type { QuestionStepProps } from "./types";

/** Rust & overzicht: zachte kaarten, één keuze per tik. */
export function QuestionStepCards({
  question,
  questionIndex,
  totalQuestions,
  selectedValue,
  onSelect,
  onBack,
  canGoBack,
}: QuestionStepProps) {
  return (
    <QuestionStepShell
      question={question}
      questionIndex={questionIndex}
      totalQuestions={totalQuestions}
      selectedValue={selectedValue}
      onSelect={onSelect}
      onBack={onBack}
      canGoBack={canGoBack}
    >
      <div className="bloom-cards" role="group" aria-label="Antwoordopties">
        {bloomScale.labels.map((label, index) => (
          <button
            key={index}
            type="button"
            className={`bloom-cards__item${selectedValue === index ? " bloom-cards__item--selected" : ""}`}
            aria-pressed={selectedValue === index}
            onClick={() => onSelect(index)}
          >
            <span className="bloom-cards__label">{label}</span>
          </button>
        ))}
      </div>
    </QuestionStepShell>
  );
}
